import { Row } from 'antd';
import React from 'react';
import Search from '../components/Search/Search';

const SearchPage: React.FC = () => (
  <div className="page__wrapper search">
    <Row className="fixed" type="flex">
      <Search />
    </Row>
  </div>
);

export default React.memo(SearchPage);
